// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#collections .v-treeview>.v-treeview-node:first-child .v-treeview-node__level,#collections .v-treeview>.v-treeview-node:first-child .v-treeview-node__prepend{display:none}", ""]);
// Exports
module.exports = exports;
